import React from 'react'

export default function Skills() {
  return (
    <div>
      
    </div>
  )
}
